var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypcnFlashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1248 4.00098H15.1298H15.1248ZM15.1248 4.00098L12.6248 10.001L17.6248 12.899L10.1248 20.001L12.6248 14.001L7.62482 11.101L15.1248 4.00098ZM15.1248 2.00098C14.6119 2.00289 14.1189 2.19988 13.7458 2.55198L6.24882 9.64698C6.02296 9.86116 5.85021 10.1251 5.74431 10.4178C5.63841 10.7105 5.60229 11.0239 5.63882 11.333C5.71082 11.959 6.07582 12.515 6.62082 12.831L10.1028 14.852L8.27682 19.233C8.15078 19.537 8.10162 19.8675 8.13368 20.1951C8.16574 20.5227 8.27804 20.8373 8.46065 21.1112C8.64326 21.385 8.89054 21.6097 9.18063 21.7652C9.47072 21.9208 9.79467 22.0024 10.1238 22.003C10.6218 22.003 11.1168 21.817 11.4988 21.455L18.9988 14.352C19.2245 14.1379 19.3972 13.8741 19.5031 13.5816C19.609 13.2891 19.6452 12.9759 19.6088 12.667C19.5728 12.3581 19.4654 12.0619 19.2949 11.8019C19.1244 11.5419 18.8957 11.3252 18.6268 11.169L15.1448 9.15098L16.9338 4.85798C17.0785 4.55299 17.1436 4.21635 17.123 3.87942C17.1025 3.5425 16.9971 3.21624 16.8165 2.93106C16.6359 2.64587 16.3861 2.41102 16.0903 2.2484C15.7945 2.08577 15.4624 2.00065 15.1248 2.00098Z",
    fill: "#1D5AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypcnFlashOutline);
export default __webpack_public_path__ + "static/media/typcn_flash-outline.28efb30fa41cb11caaac78c37e818ca3.svg";
export { ForwardRef as ReactComponent };